import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function X({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <X.Outline {...props} /> : <X.Solid {...props} />;
}

X.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M7 7L17 17"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
        />
        <path
          d="M7 17L17 7"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

X.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M7 7L17 17"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          className="icon-outline"
        />
        <path
          d="M7 17L17 7"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
